var courses_carousel = require( '../global/courses-carousel' );

var targeted_landing_page = (function ( $ ) {

	var _init = function () {
		var $carousel = $('.courses-carousel');

		$( 'html' ).css( 'scroll-behavior',  'smooth' ); // Makes targeted links scroll to section nicely

		if ( $carousel.length > 0) {
			courses_carousel.setup( $carousel );
		}
	};

	if ( $( 'html body' ).is( '.page-template-page-targeted-landing, .page-template-page-choose-plan' ) ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = targeted_landing_page;